import type { GuidedSelfHelpRouteName, RouterConfig } from '../types';

// Pages.
import PageClients from '../../../pages/Clients';
import PageClientDetails from '../../../pages/ClientDetails';
import PageInviteClient from '../../../pages/InviteClient';
import PageLogin from '../../../pages/Login';
import PageLogout from '../../../pages/Logout';
import PageNursePracticionerAccount from '../../../pages/NursePractitionerAccount';
import PageResetPassword from '../../../pages/ResetPassword';
import PageValidateEmail from '../../../pages/ValidateEmail';
import RegisterNursePractitioner from '../../../pages/RegisterNursePractitioner';

const routesConfigGuidedSelfHelp: RouterConfig<GuidedSelfHelpRouteName> = {
  accountBase: {
    basePath: '/account',
    nl: '/nl/account',
    type: 'private',
    exact: false,
    component: PageNursePracticionerAccount,
  },
  clients: {
    basePath: '/clienten',
    nl: '/nl/clienten',
    type: 'private',
    exact: false,
    component: PageClients,
  },
  clientDetails: {
    basePath: '/client/:domain/:uid',
    nl: '/nl/client/:domain/:uid',
    type: 'private',
    component: PageClientDetails,
  },
  inviteClient: {
    basePath: '/client-uitnodigen',
    nl: '/nl/client-uitnodigen',
    type: 'private',
    component: PageInviteClient,
  },
  login: {
    basePath: '/inloggen',
    nl: '/nl/inloggen',
    type: 'public',
    component: PageLogin,
  },
  logout: {
    basePath: '/user/logout',
    nl: '/nl/user/logout',
    type: 'private',
    component: PageLogout,
  },
  register: {
    basePath: '/registreren',
    nl: '/nl/registreren',
    type: 'public',
    component: RegisterNursePractitioner,
  },
  resetPassword: {
    basePath: '/user/reset/:uid/:timestamp/:hash',
    nl: '/nl/user/reset/:uid/:timestamp/:hash',
    type: 'default',
    component: PageResetPassword,
  },
  resetPasswordLogin: {
    basePath: '/user/reset/:uid/:timestamp/:hash/login',
    nl: '/nl/user/reset/:uid/:timestamp/:hash/login',
    type: 'default',
    component: PageResetPassword,
  },
  resetPasswordRequest: {
    basePath: '/wachtwoord-vergeten',
    nl: '/nl/wachtwoord-vergeten',
    type: 'default',
    component: PageResetPassword,
  },
  validateEmail: {
    basePath: '/validate/:uid/:timestamp/:hash',
    nl: '/nl/validate/:uid/:timestamp/:hash',
    type: 'default',
    component: PageValidateEmail,
  },
};

export default routesConfigGuidedSelfHelp;
